import React, { Component } from 'react';
import './Contact.css'
import { post } from '../../Utils/request';
class Contact extends Component {
    constructor(){
        super()
        this.state={
            contact:{}
        }
    }
    componentDidMount(){
        post('/information/list')
        .then(res => {
            // console.log("Contact",res)
            this.setState({
                contact:res
            },()=>{console.log("contact",this.state.contact)})
        }).catch(res =>{
            console.log(res)
        })
    }
    render() {
        let {contact}=this.state
        return (
            <div className="footer-contact">
                <img className="wind" src='/img/wave.png' alt=""/>
                <div className="contact-container">
                    <div className="contact-en">
                        <span>CONTACT US</span>
                    </div>
                    <div className="contact-ch">
                        <div>联</div>
                        <div>系</div>
                        <div>我</div>
                        <div>们</div>
                    </div>
                    <div className="contact-info">
                            <p>{contact.contract_name}</p>
                            <p>{contact.contract_department  }</p>
                            <p>{`TEL: ${contact.tel}`}</p>
                            <p>{`FAX: ${contact.fax}`}</p>
                            <p>{`EMAIL: ${contact.email}`}</p>
                            <p>{contact.address}</p>
                            <p>{contact.en_address}</p>
                    </div>
                    <a className='bottom-info' href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank"><span className="cname">2016 © 中国国际公关关系协会™</span> 京ICP备11009004号-5</ a>
                </div>
                <div className="contact_divider"></div>
            </div>
        );
    }
}

export default Contact;